import React, {useEffect, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import {setGlobalVariable, globalVariable} from "../../store/reducers/globals";

const defaultZ = 10;
const cssImportant = (what) => what + " !important";

export const ToolbarMainToggleButton = withStyles((theme) => ({
    root: {
        color: theme.palette.tb.color.main,
    },
    selected: {
        backgroundColor: cssImportant(theme.palette.tb.color.sub),
        margin: theme.spacing(2.5),
    },
}))(ToggleButton);

export const ToolbarMainColorToggleButton = withStyles((theme) => ({
    root: {
        color: theme.palette.tb.color.main,
        "&:hover": {
            backgroundColor: cssImportant(theme.palette.tb.background.main),
        },
    },
    selected: {
        backgroundColor: cssImportant(theme.palette.tb.background.main),
        color: cssImportant(theme.palette.tb.color.sub),
        margin: theme.spacing(2.5),
    },
}))(ToggleButton);

export const ToolbarMainTBG = withStyles((theme) => ({
    grouped: {
        margin: 0,
        border: "none",
        "&:not(:first-child)": {
            borderRadius: 0,
        },
        "&:first-child": {
            borderRadius: 0,
        },
    },
}))(ToggleButtonGroup);

export const ToolbarSubToggleButton = withStyles((theme) => ({
    root: {
        color: theme.palette.tb.color.main,
        "&:hover": {
            backgroundColor: cssImportant(theme.palette.tb.background.inWindow),
        },
    },
    selected: {
        backgroundColor: cssImportant(theme.palette.tb.background.inWindow),
        color: cssImportant(theme.palette.tb.color.sub),
        margin: theme.spacing(2.5),
    },
    disabled: {
        border: "none"
    }
}))(ToggleButton);

export const ToolbarSubTBG = withStyles((theme) => ({
    grouped: {
        backgroundColor: theme.palette.tb.background.window,
        margin: 0,
        border: "none",
        "&:not(:first-child)": {
            borderRadius: 0,
        },
        "&:first-child": {
            borderRadius: 0,
        },
    },
}))(ToggleButtonGroup);

export const ToolbarButtonGroupMain = withStyles((theme) => ({
    grouped: {
        // backgroundColor: theme.palette.tb.background.window,
        margin: 0,
        border: "none",
        "&:not(:first-child)": {
            borderRadius: 0,
        },
        "&:first-child": {
            borderRadius: 0,
        },
    },
}))(ButtonGroup);

export const ToolbarButtonGroup = withStyles((theme) => ({
    grouped: {
        backgroundColor: theme.palette.tb.background.window,
        margin: 0,
        border: "none",
        "&:not(:first-child)": {
            borderRadius: 0,
        },
        "&:first-child": {
            borderRadius: 0,
        },
    },
}))(ButtonGroup);

export const ToolbarButton = withStyles((theme) => ({
    root: {
        color: theme.palette.tb.color.main,
        border: "0 !important",
        width: 46,
        height: 46,
        "&:hover": {
            backgroundColor: cssImportant(theme.palette.tb.background.inWindow),
        },
    },
    // selected: {
    //     backgroundColor: cssImportant(theme.palette.tb.background.inWindow),
    //     color: cssImportant(theme.palette.tb.color.sub),
    //     margin: theme.spacing(2.5),
    // },
    disabled: {
        border: "0 !important",
    },
}))(Button);

const useStyles = makeStyles((theme) => ({
    toolbarWindow: {
        position: "absolute",
        backgroundColor: theme.palette.tb.root.background,
        padding: "1px",
    },
    toolbarWindowTitle: {
        backgroundColor: theme.palette.tb.background.window,
        marginBottom: "1px",
        padding: "4px 6px",
        fontSize: "70%",
        textTransform: "uppercase",
        fontWeight: "bold",
        cursor: "move",
        userSelect: "none",
    },
}));

export const ToolbarWindow = (props) => {
    const classes = useStyles();

    const windowElement = useRef(null);

    const dispatch = useDispatch();
    const toolbarActiveWindowName = useSelector(globalVariable("toolbarActiveWindowName"));

    // FIXME: mobile touch move !!!
    const [windowMove, setWindowMove] = useState(null);
    const [valueZ, setValueZ] = useState(defaultZ);

    const [position, setPosition] = useState({
        top: props.top ? props.top + 50 : 40,
        left: props.left ? props.left : -10,
    });

    const isOutOfViewport = function (elem) {
        // Get element's bounding
        const bounding = elem.getBoundingClientRect();

        // Check if it's out of the viewport on each side
        const out = {};
        out.top = bounding.top < 0;
        out.left = bounding.left < 0;
        out.bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
        out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
        out.any = out.top || out.left || out.bottom || out.right;
        out.all = out.top && out.left && out.bottom && out.right;

        console.log(out.top, out.left, out.bottom, out.right);

        return out;

    };

    const onMouseMove = (e) => {
        // console.log(windowElement);
        if (windowMove) {
            // console.log(windowElement.current.getBoundingClientRect(), isInViewport(windowElement.current));

            const deltaX = e.clientX - windowMove.x;
            const deltaY = e.clientY - windowMove.y;

            const element = windowElement.current;
            // noinspection all
            const r = element.getBoundingClientRect();

            let left = position.left + deltaX;
            let top = position.top + deltaY;

            // console.log(0, windowElement.current.parentNode.getBoundingClientRect().y);
            // console.log(1, windowElement.current.parentNode.parentNode.getBoundingClientRect().y);
            // console.log(2, windowElement.current.parentNode.parentNode.parentNode.getBoundingClientRect().y);
            // console.log(3, windowElement.current.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect().y);

            // FIXME: this 50 ( = windowElement.current.parentNode.getBoundingClientRect().y ) needs to be calculated somehow ...
            if (left < 0) {
                left = 0;
            }
            if (top < 50) {
                top = 50;
            }
            if (left > (window.innerWidth || document.documentElement.clientWidth) - r.width) {
                left = (window.innerWidth || document.documentElement.clientWidth) - r.width;
            }
            if (top + 50 > (window.innerHeight || document.documentElement.clientHeight) - r.height) {
                top = (window.innerHeight || document.documentElement.clientHeight) - r.height - 50;
            }

            setPosition({
                left: left,
                top: top,
            });

            setWindowMove({x: e.clientX, y: e.clientY});
        }
    };

    const onMouseDown = (e) => {
        setWindowMove({x: e.clientX, y: e.clientY});

        setMoved(true);

        dispatch(setGlobalVariable({
            name: "toolbarActiveWindowName",
            value: props.title,
        }));
    };

    const [moved, setMoved] = useState(false);
    const onMouseUp = (e) => {
        setWindowMove(null);
    };

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove, false);
        window.addEventListener("mouseup", onMouseUp, false);
        return () => {
            window.removeEventListener("mousemove", onMouseMove, false);
            window.removeEventListener("mouseup", onMouseUp, false);
        };
    }, [windowMove]);

    useEffect(() => {
        setValueZ(toolbarActiveWindowName === props.title ? defaultZ + 1 : defaultZ);
    }, [toolbarActiveWindowName]);

    useEffect(() => {
        if(!moved) {
            setPosition({
                top: position.top,
                left: props.left
            });
        }
    }, [props]);

    const styles = _.merge(_.cloneDeep(position), {zIndex: valueZ}, {display: !!props.active ? "block" : "none"});
    return (
        <div className={classes.toolbarWindow} style={styles} ref={windowElement}>
            <div className={classes.toolbarWindowTitle} onMouseDown={onMouseDown}>
                {props.title}
            </div>
            <div>{props.children}</div>
        </div>
    );
};
